import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
    listHeader: {
        padding: theme.spacing(1, 2, 2, 3)
    },
    skeleton: {
        borderRadius: "4px"
    },
}));